/**
 * Constants for i18n namespaces used throughout the application
 * Use these constants instead of string literals for type safety
 */
export const NAMESPACES = {
  COMMON: 'common',
  AUTH: 'auth',
  DASHBOARD: 'dashboard',
  USERS: 'users',
  THEME: 'theme',
  ERRORS: 'errors',
  WELCOME: 'welcome',
  LEGAL: 'legal',
  CONTENT: 'content'
} as const;

export type Namespace = typeof NAMESPACES[keyof typeof NAMESPACES]; 